import {AdminUserPageContent} from './AdminUserPageContent';

export default AdminUserPageContent;
